import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter           from "@/services/utils/figureFormatter";
import { useStore } from "vuex";
import useDate from '@/services/utils/day';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {
    const { formatDate } = useDate();
    const store = useStore();
    const { commaFormat } = figureFormatter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, sales, date, payload) => {

        var doc = {
            pageSize: 'A4',
            pageMargins: [ 30, 100, 30, 80 ],
            pageOrientation: 'landscape',
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(sales, date, payload),


            styles : {
                header: {
                    fontSize: 24
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'Daily Sales Report'
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (sales, date, payload) => {
        return [
            {
                text: 'Daily Sales Report',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                decoration: 'underline'
            },

            {
                stack: [
                    {
                        text: `Date: ${date.startDate} - ${date.endDate}`
                    },

                    {
                        text: `${payload.businessName ? 'Business Unit: ' +  payload.businessName : ''}`
                    },

                    {
                        text: `${payload.consultantName ? 'Consultant: ' + payload.consultantName : ''}`
                    },

                    {
                        text: `${payload.createdBy ? 'Created By: ' + payload.createdBy : ''}`
                    },

                    {
                        text: `${payload.billType ? 'Bill Type: ' + payload.billType : ''}`
                    },

                    {
                        text: `${payload.referrer ? 'Referrer Name: ' + payload.referrer : ''}`
                    },

                    {
                        text: `${payload.contactOwner ? 'Contact Owner: ' + payload.contactOwner : ''}`
                    },

                    {
                        text: `${payload.patientId ? 'Patient ID: ' + payload.patientId : ''}`
                    },
                ]
            },

            {
                style: 'tableExample',
                fontSize: 8,
                margin: [0, 10, 0, 0],
                table: {
                    widths: ['auto', 40, 40, '*', 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40],
                    body: getTableBody(sales)
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const getTableBody = (sales) => {
        const header = getTableHead();
        const row = getTableRow(sales);
        return [
            header,
            ...row
        ]
    }

    const getTableRow = (sales) => {
        const data = [];
        sales.map((child) => {
            const row = [
                { text: child.bill_number },
                { text: child.date },
                { text: child.contact.patient_id },
                { text: child.contact.full_name },
                { text: child.contact.mobile_no },
                { text: '' },
                { text: '' },
                { text: commaFormat(child.subtotal_amount + child.vat_amount), alignment: 'right' },
                { text: commaFormat(child.total_discount), alignment: 'right' },
                { text: commaFormat(child.subtotal_amount + child.vat_amount - child.total_discount), alignment: 'right' },
                { text: commaFormat(child.discount), alignment: 'right' },
                { text: commaFormat(child.adjusted_amount), alignment: 'right' },
                { text: commaFormat(child.paid_amount), alignment: 'right' },
                { text: commaFormat(child.subtotal_amount + child.vat_amount - child.total_discount - child.paid_amount - child.adjusted_amount), alignment: 'right' },
                { text: commaFormat(child.service_resource_cost), alignment: 'right' }
            ];
            data.push(row);
        })
        const totalRow = [
            { text: `Total (${sales.length})`, colSpan: 7, alignment: 'right' },
            { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' },
            { text: commaFormat(getTotalSalesAmount(sales)), alignment: 'right' },
            { text: commaFormat(getTotalDiscount(sales)), alignment: 'right' },
            { text: commaFormat(getTotalNetBillAmount(sales)), alignment: 'right' },
            { text: commaFormat(getTotalDicountAmount(sales)), alignment: 'right' },
            { text: commaFormat(getTotalAdjustedAmount(sales)), alignment: 'right' },
            { text: commaFormat(getTotalPaidAmount(sales)), alignment: 'right' },
            { text: commaFormat(getTotalNetBillAmount(sales) - getTotalPaidAmount(sales) - getTotalAdjustedAmount(sales)), alignment: 'right' },
            { text: commaFormat(getTotalResourceCostAmount(sales)), alignment: 'right' },
        ];

        data.push(totalRow);
        return data
    }

    const getTotalResourceCostAmount = (item) => {
        return item.reduce((total, saleMaster) => total + saleMaster.service_resource_cost, 0);
    }

    const getTotalSalesAmount = (item) => {
        return item.reduce((total, saleMaster) => total + (saleMaster.subtotal_amount + saleMaster.vat_amount), 0);
    }

    const getTotalDiscount = (item) => {
        return item.reduce((total, saleMaster) => total + saleMaster.total_discount, 0);
    }

    const getTotalNetBillAmount = (item) => {
        return item.reduce((total, saleMaster) => total + (saleMaster.subtotal_amount + saleMaster.vat_amount - saleMaster.total_discount), 0);
    }

    const getTotalPaidAmount = (item) => {
        return item.reduce((total, saleMaster) => total + saleMaster.paid_amount, 0);
    }

    const getTotalAdjustedAmount = (item) => {
        return item.reduce((total, saleMaster) => total + saleMaster.adjusted_amount, 0);
    }

    const getTotalDicountAmount = (item) => {
        return item.reduce((total, saleMaster) => total + saleMaster.discount, 0);
    }

    const getTableHead = () => {
        return [
            { text: 'INVOICE NO' },
            { text: 'INVOICE DATE' },
            { text: 'PATIENT ID' },
            { text: 'PATIENT NAME' },
            { text: 'PATIENT MOBILE NO' },
            { text: 'UNIT' },
            { text: 'ADMISSION NO' },
            { text: 'TOTAL SALES AMOUNT' , alignment: 'right' },
            { text: 'SETTLEMENT DIS' , alignment: 'right' },
            { text: 'NET BILL AMOUNT' , alignment: 'right' },
            { text: 'BILL SETT. DISCOUNT' , alignment: 'right' },
            { text: 'ADJUSTED AMOUNT' , alignment: 'right' },
            { text: 'NET COLLECTION' , alignment: 'right' },
            { text: 'DUE AMOUNT' , alignment: 'right' },
            { text: 'Resource Cost Amount' , alignment: 'right' }
        ]
    }

    const getHeader = (company) => {
        return {
            margin: [ 30, 25, 30, 10 ],
            columns: [
                {
                    alignment: 'left',
                    image: company.logo64,
                    maxHeight: 60
                },

                {
                    alignment: 'right',
                    stack: [
                        company.name,
                        'Address: ' + company.address,
                        'Phone: ' + company.phone,
                        'E-mail: ' + company.email
                    ]
                }
            ]
        }
    }

    const getFooter = (userName) =>{
        return {
            margin: [ 25, 0 ],
            columns: [
                {
                    columns: [
                        {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        }
                    ]
                },

                {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                }
            ]
        }
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;
